exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".zoneCard-487bfaed{margin-right:40px;width:275px;flex-grow:0}.zoneCard-487bfaed.collapsed-a6a6a5d7{width:100%;margin-left:auto;margin-right:auto}.zoneCard-487bfaed a,.zoneCard-487bfaed a:visited{color:#212121}.zoneCard-487bfaed a:hover{color:#FA6400}.content-7a08be3d{padding:15px 20px 20px 20px;min-height:165px;text-align:left;line-height:26px;display:flex;flex-flow:column wrap}.content-7a08be3d .country-60e3a099{flex-grow:0}.content-7a08be3d :hover{color:#FA6400;text-decoration:none;cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"zoneCard": "zoneCard-487bfaed",
	"collapsed": "collapsed-a6a6a5d7",
	"content": "content-7a08be3d",
	"country": "country-60e3a099"
};